// SupportDetailModal.jsx
import React, { useEffect, useState, useMemo } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Spinner
} from "reactstrap";

// ----------------------
// Convert PascalCase → camelCase
// ----------------------
function normalizeKeys(obj) {
  if (!obj || typeof obj !== "object") return obj;
  const out = {};
  Object.keys(obj).forEach((k) => {
    const camel = k.charAt(0).toLowerCase() + k.slice(1);
    out[camel] = obj[k];
  });
  return out;
}

function normalizeArray(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((x) => normalizeKeys(x));
}

// ----------------------------------------------------
// FIELD CONFIG – เดิมของคุณ
// ----------------------------------------------------
const FIELD_CONFIG = {
  1: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "year", label: "ปี พ.ศ." },
    { key: "passTest", label: "จำนวนผู้ผ่านการทดสอบ" },
    { key: "lawOccupationName", label: "สาขาอาชีพ" },
    { key: "testOccupationName", label: "สาขา" },
    { key: "personTotal", label: "จำนวน (คน)" },
    { key: "paymentAmount", label: "จำนวนเงิน" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],

  4: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "year2", label: "ปีนำส่งเงินสมทบ" },
    { key: "receiptDate", label: "วันที่ใบเสร็จ" },
    { key: "amount", label: "จำนวนเงิน" },
    { key: "year1", label: "ปี พ.ศ." },
    { key: "avgMan", label: "ลูกจ้างเฉลี่ย" },
    { key: "perc", label: "% การฝึก" },
    { key: "lawTrainMan", label: "ลูกจ้างตามกฎหมาย" },
    { key: "spkTrainMan", label: "พัฒนาฝีมือฯ" },
    { key: "train", label: "อบรม" },
    { key: "test", label: "ทดสอบ" },
    { key: "oloc", label: "นอกสถานที่" },
    { key: "paymentAmount", label: "จำนวนเงิน" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],
  5: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "receiveYear", label: "ปีที่รับเงินสมทบ" },
    { key: "avgMan", label: "ลูกจ้างเฉลี่ย" },
    { key: "avg70", label: "70%" },
    { key: "spkTrainMan", label: "พัฒนาฝีมือฯ" },
    { key: "trainPercent", label: "% การฝึก" },
    { key: "cntGt70Lt80", label: "70–80%" },
    { key: "cntGe80", label: "≥ 80%" },
    { key: "amt70", label: "วงเงิน 70%" },
    { key: "amt80", label: "วงเงิน 80%" },
    { key: "train", label: "อบรม" },
    { key: "test", label: "ทดสอบ" },
    { key: "oloc", label: "นอกสถานที่" },
    { key: "paymentAmount", label: "จำนวนเงิน" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],


  // 5: [
  //   { key: "supportNo", label: "เลขที่คำขอ" },
  //   { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
  //   { key: "receiveYear", label: "ปีที่รับเงินสมทบ" },
  //   { key: "avgMan", label: "ลูกจ้างเฉลี่ย" },
  //   { key: "avg70", label: "70%" },
  //   { key: "spkTrainMan", label: "พัฒนาฝีมือฯ" },
  //   { key: "trainPercent", label: "% การฝึก" },
  //   { key: "cntGt70Lt80", label: "70–80%" },
  //   { key: "cntGe80", label: "≥ 80%" },
  //   { key: "amt70", label: "วงเงิน 70%" },
  //   { key: "amt80", label: "วงเงิน 80%" },
  //   { key: "train", label: "อบรม" },
  //   { key: "test", label: "ทดสอบ" },
  //   { key: "oloc", label: "นอกสถานที่" },
  //   { key: "paymentAmount", label: "จำนวนเงิน" },
  //   { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  // ],

  6: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "paymentAmount", label: "จำนวนเงิน" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],

  7: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "paymentAmount", label: "จำนวนเงิน" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],

  // 8: [
  //   { key: "supportNo", label: "เลขที่คำขอ" },
  //   { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
  //   { key: "innovationName", label: "นวัตกรรม" },
  //   { key: "innovationCourseName", label: "หลักสูตร" },
  //   { key: "updateDate", label: "ปรับปรุงล่าสุด" },
  //   { key: "classAmount", label: "จำนวนคลาส" },
  //   { key: "hour", label: "ชั่วโมงรวม" },
  //   { key: "personTotal", label: "ผู้เข้าอบรมรวม" },
  //   { key: "tutorHourAmount", label: "ค่าผู้สอนรวม" },
  //   { key: "materialAmount", label: "ค่าวัสดุรวม" },
  //   { key: "amount", label: "ค่าใช้จ่ายรวม" },
  //   { key: "startDate", label: "เริ่ม" },
  //   { key: "endDate", label: "สิ้นสุด" },
  //   { key: "paymentAmount", label: "เงินช่วยเหลือ" },
  //   { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  // ],
  8: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "innovationName", label: "นวัตกรรม" },
    { key: "innovationCourseName", label: "หลักสูตร" },
    { key: "updateDate", label: "ปรับปรุงล่าสุด" },
    { key: "classAmount", label: "จำนวนคลาส" },
    { key: "hour", label: "ชั่วโมงรวม" },
    { key: "personTotal", label: "ผู้เข้าอบรมรวม" },
    { key: "tutorHourAmount", label: "ค่าผู้สอนรวม" },
    { key: "materialAmount", label: "ค่าวัสดุรวม" },
    { key: "personAmount", label: "ค่าใช้จ่ายรวม" },
    { key: "startDate", label: "เริ่ม" },
    { key: "endDate", label: "สิ้นสุด" },
    { key: "paymentAmount", label: "เงินช่วยเหลือ" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],

  3: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "paymentAmount", label: "เงินช่วยเหลือ" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],

  9: [
    { key: "supportNo", label: "เลขที่คำขอ" },
    { key: "supportName", label: "ผู้ขอรับเงินช่วยเหลือ" },
    { key: "paymentAmount", label: "เงินช่วยเหลือ" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ]
};

// ----------------------------------------------------
// FALLBACK FIELDS — เมื่อ DataVersion = null
// ----------------------------------------------------
const FIELD_CONFIG_FALLBACK = {
  // 5: [
  //   { key: "amount", label: "จำนวนเงิน" },
  //   { key: "avgMan", label: "ลูกจ้างเฉลี่ย" },
  //   { key: "lawTrainMan", label: "ลูกจ้างตามกฎหมาย" },
  //   { key: "oloc", label: "นอกสถานที่" },
  //   { key: "perc", label: "% การฝึก" },
  //   { key: "receiptDate", label: "วันที่ใบเสร็จ" },
  //   { key: "spkTrainMan", label: "พัฒนาฝีมือฯ" },
  //   { key: "test", label: "ทดสอบ" },
  //   { key: "train", label: "อบรม" },
  //   { key: "year1", label: "ปี พ.ศ." },
  //   { key: "year2", label: "ปีนำส่ง" },
  //   { key: "paymentAmount", label: "จำนวนเงิน" },
  //   { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  // ],
  5: [
    { key: "avgMan", label: "ลูกจ้างเฉลี่ย" },
    { key: "avg70", label: "70%" },
    { key: "spkTrainMan", label: "พัฒนาฝีมือฯ" },
    { key: "percent", label: "% การฝึก" },
    { key: "more70", label: "เกิน 70%" },
    { key: "amt", label: "จำนวนเงิน" },
    { key: "train", label: "อบรม" },
    { key: "test", label: "ทดสอบ" },
    { key: "oloc", label: "นอกสถานที่" },
    { key: "paymentAmount", label: "จำนวนเงิน" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ],



  6: [
    { key: "avgMan", label: "ลูกจ้างเฉลี่ย" },
    { key: "avg70", label: "70%" },
    { key: "spkTrainMan", label: "พัฒนาฝีมือฯ" },
    { key: "percent", label: "% การฝึก" },
    { key: "more70", label: "เกิน 70%" },
    { key: "amt", label: "จำนวนเงิน" },
    { key: "train", label: "อบรม" },
    { key: "test", label: "ทดสอบ" },
    { key: "oloc", label: "นอกสถานที่" },
    { key: "paymentAmount", label: "จำนวนเงิน" },
    { key: "paymentDate", label: "วันที่จ่ายเงิน" }
  ]
};

// ----------------------------------------------------
// CHILD CONFIG — ของเดิม
// ----------------------------------------------------
const CHILD_CONFIG = {
  3: [
    { key: "lawOccupationName", label: "สาขาอาชีพ" },
    { key: "occupationName", label: "อาชีพ" },
    { key: "personTotal", label: "จำนวนคน" },
    { key: "amountTotal", label: "ยอดเงิน" },
    { key: "receiptNo", label: "เลขที่ใบเสร็จ" },
    { key: "receiptDate", label: "วันที่ใบเสร็จ" }
  ],

  9: [
    { key: "lawOccupationName", label: "สาขาอาชีพ" },
    { key: "occupationName", label: "อาชีพ" },
    { key: "personTotal", label: "จำนวนคน" },
    { key: "amountTotal", label: "ยอดเงิน" },
    { key: "receiptNo", label: "เลขที่ใบเสร็จ" },
    { key: "receiptDate", label: "วันที่ใบเสร็จ" }
  ],

  6: [
    { key: "cer2Num", label: "เลขรมฐ.2" },
    { key: "cer2ApproveDate", label: "วันที่ออก" },
    { key: "lawOccupationName", label: "สาขาอาชีพ" },
    { key: "testOccupationName", label: "สาขา" },
    { key: "level", label: "ระดับ" },
    { key: "personTotal", label: "จำนวนลูกจ้างที่ทดสอบ" },
    { key: "employeeTotal", label: "จำนวนลูกจ้างในตำแหน่งงาน" }
  ],

  7: [
    { key: "certificateNo", label: "ใบรับรอง" },
    { key: "certificateDate", label: "วันที่รับรอง" },
    { key: "lawOccupationName", label: "สาขาอาชีพ" },
    { key: "testOccupationName", label: "สาขา" },
    { key: "level", label: "ระดับ" },
    { key: "employeeFullName", label: "ชื่อ-สกุล" },
    { key: "payRateStartDate", label: "เริ่มอัตราค่าจ้าง" },
    { key: "payRateEndDate", label: "สิ้นสุดอัตราค่าจ้าง" }
  ],

  8: [
    { key: "courseName", label: "หลักสูตร" },
    { key: "startDate", label: "เริ่ม" },
    { key: "endDate", label: "สิ้นสุด" },
    { key: "hour", label: "ชั่วโมง" },
    { key: "personTotal", label: "คน" },
    { key: "tutorHourAmount", label: "ค่าผู้สอน" },
    { key: "materialAmount", label: "ค่าวัสดุ" },
    { key: "amount", label: "รวม" }
  ],

};

// ----------------------------------------------------
// Row Component
// ----------------------------------------------------
function Row({ label, value }) {
  if (value === null || value === undefined || value === "") return null;
  return (
    <tr>
      <th style={{ width: "35%" }}>{label}</th>
      <td>{String(value)}</td>
    </tr>
  );
}

// ----------------------------------------------------
// MAIN MODAL
// ----------------------------------------------------
export default function SupportDetailModal({
  isOpen,
  toggle,
  supportId,
  supportTypeId
}) {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState("");

  // Fetch data
  useEffect(() => {
    if (!isOpen || !supportId) return;

    let abort = false;

    const load = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await fetch(
          `/api/SupportOperation/detail/${supportTypeId}/${supportId}`
        );
        if (!res.ok) throw new Error();

        const json = await res.json();

        const normalized = {
          ...json,
          data: normalizeKeys(json.data),
          children: normalizeArray(json.children)
        };

        if (!abort) setDetail(normalized);
      } catch {
        if (!abort) setError("ไม่สามารถโหลดข้อมูลได้");
      } finally {
        if (!abort) setLoading(false);
      }
    };

    load();

    return () => (abort = true);
  }, [isOpen, supportId, supportTypeId]);

  const data = detail?.data || {};
  const children = detail?.children || [];

  // --------------------------
  // เลือกชุด fields แบบ Dynamic
  // --------------------------
  const fields = useMemo(() => {
    const dv = data?.dataVersion;

    if (supportTypeId === 4 && (dv === null || dv === undefined)) {
      return FIELD_CONFIG_FALLBACK[4];
    }

    if (supportTypeId === 5 && (dv === null || dv === undefined)) {
      return FIELD_CONFIG_FALLBACK[5];
    }

    return FIELD_CONFIG[supportTypeId] || [];
  }, [supportTypeId, data]);

  // CHILD CONFIG
  const childConfig = CHILD_CONFIG[supportTypeId] || [];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable centered>
      <ModalHeader toggle={toggle}>รายละเอียด</ModalHeader>

      <ModalBody>
        {loading && (
          <div className="d-flex align-items-center gap-2">
            <Spinner size="sm" />
            <span>กำลังโหลดข้อมูล...</span>
          </div>
        )}

        {!loading && error && <div className="text-danger">{error}</div>}

        {!loading && !error && (
          <>
            {/* ตารางข้อมูลหลัก */}
            <Table bordered responsive size="sm">
              <tbody>
                {fields.map((f) => (
                  <Row key={f.key} label={f.label} value={data[f.key]} />
                ))}
              </tbody>
            </Table>

            {/* CHILD TABLE */}
            {children.length > 0 && childConfig.length > 0 && (
              <>
                <h6 className="mt-3">รายละเอียดเพิ่มเติม</h6>

                <Table bordered responsive size="sm">
                  <thead>
                    <tr>
                      {childConfig.map((c) => (
                        <th key={c.key}>{c.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {children.map((row, idx) => (
                      <tr key={idx}>
                        {childConfig.map((c) => (
                          <td key={c.key}>{row[c.key] ?? "-"}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          ปิด
        </Button>
      </ModalFooter>
    </Modal>
  );
}
